// Componentes personalizados
import Form from "../../components/Form";
import BannerNavegacao from "../../components/BannerNavegacao";
import BlocoTitulo from "../../components/BlocoTituloTextoBotaoImagem";
import { BotaoFaleConosco, BotaoEnviarMensagem } from "../../components/Botoes";
import SecaoPagina from "../../components/SecaoPagina";
import PageLayout from "../../layouts/PageLayout";
// Imagens
import ImagemMulherCelularHomem from "../../assets/imagens/MulherCelularHomem.svg";
import FundoVerde from "../../assets/imagens/FundoVerdeGrafo.webp";
import { useEffect } from "react";
import Home from "../home";

export default function PaginaAcessoRemoto() {
  const handleDownload = () => {
    window.location.href =
      "https://grvqeggss6hd.objectstorage.sa-saopaulo-1.oci.customer-oci.com/n/grvqeggss6hd/b/waychef/o/acessoremoto%2FAcessoRemoto.exe";
  };

  useEffect(() => {
    handleDownload();
  }, []);

  return <Home />;
}
